import { render } from "./Attachments.vue?vue&type=template&id=77453676"
import script from "./Attachments.vue?vue&type=script&lang=js"
export * from "./Attachments.vue?vue&type=script&lang=js"

import "./Attachments.vue?vue&type=style&index=0&id=77453676&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/orders/Attachments.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77453676"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77453676', __exports__)) {
    console.log('reload')
    api.reload('77453676', __exports__)
  }
  
  module.hot.accept("./Attachments.vue?vue&type=template&id=77453676", () => {
    console.log('re-render')
    api.rerender('77453676', render)
  })

}


export default __exports__